import axios from "./axios";
import { applyTenantScopeHeaders } from "../../context/platformAdminContext.utils";
import { getJourneyHeaders } from "../../Utils/journeyHeaders";
import { getToken } from "helpers/Tokens";
import { apiCall } from "./service";
import {
  URL_HRM_FOLDER_LIST,
  URL_EMPLOYEE_HRM_FORM_CATEGORIES,
  URL_EMPLOYEE_HRM_SUBMITTED_FORMS_LIST_BY_CATEGORY,
  URL_QUICK_BOOKS_EMPLOYEE,
  URL_QUICK_BOOKS_SYNC_EMPLOYEE,
  URL_WORKER_WYZED_STATUS,
  URL_WORKER_WYZED_TRAINING,
  URL_WORKER_WYZED_CERTIFICATE,
  URL_WORKER_WYZED_START_TRAINING,
} from "./URL";

const token = localStorage.getItem("accessToken");

export const api = {
  getFolderLIstForHrm(params) {
    return apiCall.get({
      url:
        params && params.folder_uuid
          ? `${URL_HRM_FOLDER_LIST}?worker_uuid=${params.uuid}&folder_uuid=${params.folder_uuid}`
          : `${URL_HRM_FOLDER_LIST}?worker_uuid=${params.uuid}`,
      isAuthToken: token,
      skipQueryParams: true,
      params: {},
    });
  },
  hrmFormCategoriesList() {
    return apiCall.get({
      url: `${URL_EMPLOYEE_HRM_FORM_CATEGORIES}`,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  hrmSubmittedFormsListByCategory(params) {
    return apiCall.post({
      url: `${URL_EMPLOYEE_HRM_SUBMITTED_FORMS_LIST_BY_CATEGORY}?c_id=${params.c_id}`,
      isAuthToken: token,
      skipQueryParams: false,
      params,
    });
  },
  quickBooksEmployeeList() {
    return apiCall.get({
      url: URL_QUICK_BOOKS_EMPLOYEE,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  syncQuickBooksEmployees() {
    return apiCall.get({
      url: URL_QUICK_BOOKS_SYNC_EMPLOYEE,
      isAuthToken: token,
      skipQueryParams: false,
      params: {},
    });
  },
  getWorkerWyzedStatus() {
    return apiCall.get({
      url: URL_WORKER_WYZED_STATUS,
      isAuthToken: token,
      params: {},
    });
  },
  getWorkerWyzedTraining() {
    return apiCall.get({
      url: URL_WORKER_WYZED_TRAINING,
      isAuthToken: token,
      params: {},
    });
  },
  startWorkerWyzedTraining(trainingRecordId) {
    return apiCall.get({
      url: URL_WORKER_WYZED_START_TRAINING(trainingRecordId),
      isAuthToken: token,
      params: {},
    });
  },
  downloadWorkerWyzedCertificate(trainingRecordId) {
    const authToken = getToken();
    const headers = {
      Accept: "application/pdf,*/*",
      ...getJourneyHeaders(),
    };
    applyTenantScopeHeaders(headers);
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }
    return axios.get(URL_WORKER_WYZED_CERTIFICATE(trainingRecordId), {
      responseType: "blob",
      headers,
      timeout: 90000,
    });
  },
};

export default api;
